/* eslint-disable */
export default {
  noActiveCalls: 'Nenhuma chamada ativa',
  noRecords: 'Nenhum resultado encontrado.',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noRecords"@#@ @source: @#@"No results found."@#@
